module.exports = __webpack_public_path__ + "static/media/ybor-slide-02.36df93e2.png";